import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { genericMemo } from '../../../utils/index.js';

function TableRow(props) {
  const {
    className,
    children,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement("tr", _extends({
    className: className
  }, otherProps), children);
}

var TableRow$1 = genericMemo(TableRow);

export { TableRow$1 as default };
//# sourceMappingURL=index.js.map
